import React from "react";
import SelectRadio from "@components/InquiryLogistics/SelectRadio";
import Select from "@components/InquiryLogistics/Select";
import Cascader from "@components/InquiryLogistics/Cascader";
import MultiSelect from "@components/InquiryLogistics/MultiSelect";
import CheckBoxSelect from "@components/InquiryLogistics/CheckBoxSelect";
import InputText from "@components/InquiryLogistics/InputText";
import TextAreaCop from "@components/InquiryLogistics/TextAreaCop";
import { InquirySecondInformation } from "@Types/business";
import SelectKind from "@components/InquiryLogistics/SelectKind";

type ISwitchSupplies = {
  item: InquirySecondInformation["form"]["fields"][0];
  formParams: any[];
  onChange: (params: any, type?: any) => void;
  parentItemId: number;
};
export function switchSupplies(props: ISwitchSupplies) {
  const { item, formParams, onChange, parentItemId } = props;

  let row;
  switch (item.type) {
    case "radio":
      row = <SelectRadio parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    case "select":
      row = <Cascader parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
    case "cascader":
      row = <Cascader parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    case "text":
      row = <InputText parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    case "multi-select":
      row = <MultiSelect parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    case "checkbox":
      row = <CheckBoxSelect parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    case "textarea":
      row = <TextAreaCop parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    case "kind":
      row = <SelectKind parentItemId={parentItemId} item={item} onChange={onChange} formParams={formParams} />;
      break;
    // textarea
    default:
      break;
  }
  return row;
}

export type ISuperFrom = {
  formParams: any[];
  onChange: (params: any, type?: any) => void;
};

interface ISuperFormProps extends ISuperFrom {
  item: InquirySecondInformation["form"]["fields"][0];
  formParams: any[];
  onChange: (params: any, type?: any) => void;
  parentItemId: number;
}

const SuperForm: React.FC<ISuperFormProps> = (props) => {
  return <>{switchSupplies(props)}</>;
};

export default SuperForm;
